module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/target02-d26e31fa00bce25db96fed9679404035.png";